import RankEight from '@assets/icons/rank-eight.svg'
import { Icon } from './Icon'

export const RankEightIcon = Icon(RankEight)
